import _ from 'lodash';
import moment from 'moment';

const DocumentsServiceFactory = (NewBackendService, $log, $q, $filter, endPoints, docService) => {
  'ngInject';

  const IdTermConvMerchant = 200;
  const requestDocList = {
    userContext: {},
    data: {
      request: {
        listDocumentsRequest: {}
      }
    }
  };
  const url = 'comdata/listDocuments';

  const CATEGORY = {
    APP: 'APP',
    CONTO_CORRENTE: 'CONTO_CORRENTE',
    FIRMA: 'FIRMA_DIGITALE',
    CARTA: 'CARTA_PREPAGATA',
    CARTA_CNT: 'CARTA_PREPAGATA_CONTR'
  };

  const DATE_FORMAT = 'DD.MM.YYYY';

  const loadEstrattoConto = () => {
    return $q(function(resolve, reject) {
      NewBackendService.invokeWebApiPost('movimenti/getAccountableMonth', {
        userContext: {},
        data: {
          request: {
            getAccountableMonthRequest: {}
          }
        }
      }, true).then(response => {
        const rawAccountableMonths = response.data.response.getAccountableMonthResponse.months;
        if (typeof rawAccountableMonths !== undefined && rawAccountableMonths.length > 0) {
          const fetchedDocs = _.map(rawAccountableMonths, month => {
            const m = moment(month);
            const titolo = $filter('translate')('profile.documents.movement') + ' ' + $filter('translate')('common.date.month') + ' ' + m.format('MMMM YYYY');
            return {
              type: 1,
              date: moment(month).format(DATE_FORMAT),
              dateunix: moment(month).unix(),
              year: moment(month).year(),
              title: titolo,
              show: true,
              action: () => {
                docService.showDoc(`${endPoints.webApiUrl}static-assets/documents/movimenti/${month}/`, false);
              }
            };
          });
          _.uniq(fetchedDocs);
          resolve(fetchedDocs);
        } else {
          $log.debug('loadEstrattoContoLv01', 'No movements found');
          resolve([]);
        }
      }, reason => {
        $log.error('DocumentiController', 'init', reason);
        reject(reason);
      });
    });
  };


  const fetchDocumentComdata = (result) => {
    let documenti = result.data.response.listDocumentsResponse.documents;
    const resultObj = {
      app: [],
      bankAccount: [],
      signature: [],
      prepaid: [],
      reporting: [],
      merchant: []
    };
    const cartaPrepagataNoCntr = [];
    const cartaPrepagataCntr = [];

    if (documenti !== undefined) {
      if (!Array.isArray(documenti)) {
        documenti = [documenti];
      }
      _.each(documenti, (doc) => {
        switch (doc.categoria) {
          case CATEGORY.APP:
            resultObj.app.push(doc);
            break;
          case CATEGORY.CONTO_CORRENTE:
            resultObj.bankAccount.push(doc);
            break;
          case CATEGORY.FIRMA:
            resultObj.signature.push(doc);
            break;
          case CATEGORY.CARTA:
            cartaPrepagataNoCntr.push(doc);
            break;
          case CATEGORY.CARTA_CNT:
            cartaPrepagataCntr.push(doc);
            break;
          default:
            loadEstrattoConto().then(res => {
              resultObj.reporting = res;
            }, reason => {
              $log.error(`listaDocumenti`, `loadCondensedDocuments`, reason);
            });
            break;
        }
      });
      resultObj.prepaid = cartaPrepagataCntr.length ? cartaPrepagataCntr : cartaPrepagataNoCntr;
    }
    return resultObj;
  };


  const service = {
    getDocumentList: () => $q((resolve, reject) => {
      NewBackendService.invokeWebApiPost(url, requestDocList).then((response) => {
        resolve(fetchDocumentComdata(response));
      }, (reason) => {
        $log.error('DocumentsService', 'getListDoc', reason);
        reject(reason);
      });
    }),

    getMerchantConv: () => $q((resolve, reject) => {
      NewBackendService.invokeWebApiGet('/api/usr/v2/users/me/terms', true).then((termsResponse) => {
        resolve(parseTermsResponse(termsResponse.data._embedded['accepted-terms']));
      }, reject);
    }),

    /*getMerchantConv: () => $q((resolve, reject) => {
      const requestGetTerminiAccettati = {
        data: {
          request: {
            getTerminiAccettatiRifiutatiRequest: {}
          }
        },
        userContext: {}
      };

      NewBackendService.invokeWebApiPost('registrazione/getTerminiAccettatiRifiutati', requestGetTerminiAccettati).then((result) => {
        if (result && 'data' in result) {
          const term = result.data.response.getTerminiAccettatiRifiutatiResponse.terminiAccettatiRifiutati
            .filter((o) => o.idtermini === IdTermConvMerchant);
          resolve(term);
        } else {
          reject('Wrong response from the service');
        }
      }, (reason) => {
        reject(reason);
      });
    }),*/

    showDoc: (doc) => {
      const ticket = doc.url.split('?')[1];
      const urlDoc = `${endPoints.webApiUrl}static-assets/documents/comdata/${ticket}/${doc.uuid}/getDoc`;
      docService.showDoc(urlDoc, false);
    }
  };

  return service;
};

export default DocumentsServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/documents.factory.js
 **/